import {
    SET_FILTER_STATUS,
    SET_SAVE_BUTTON_STATUS,
    SET_SEARCH_TITLE,
    SET_SEARCH_DESCRIPTION
} from '../../actions';

const initialState = {
    filter: false,
    button: false,
    title: '',
    description: ''
}

function nameSearchReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_FILTER_STATUS:
            newState.filter = action.filter;
            newState.button = state.button;
            newState.title = state.title;
            newState.description = state.description;
            return newState;
        
        case SET_SAVE_BUTTON_STATUS:
            newState.filter = state.filter;
            newState.button = action.button;
            newState.title = state.title;
            newState.description = state.description;
            return newState;
        
        case SET_SEARCH_TITLE:
            newState.filter = state.filter;
            newState.button = state.button;
            newState.title = action.title;
            newState.description = state.description;
            return newState;
        
        case SET_SEARCH_DESCRIPTION:
            newState.filter = state.filter;
            newState.button = state.button;
            newState.title = state.title;
            newState.description = action.description;
            return newState;
            
        default:
            return state;

    }
}

export default nameSearchReducer;
